import { Stack, Text } from "@mantine/core";
// eslint-disable-next-line no-restricted-imports
import { Dropzone, type DropzoneProps } from "@mantine/dropzone";
import { IconCircleCheck, IconCircleX, IconUpload } from "@tabler/icons-react";
import React from "react";
import { THEME_VARS } from "../../utils/constants";

interface DropzoneWithContentProps extends DropzoneProps {
  textContent?: React.ReactNode;
}

function DropzoneWithContent({
  textContent,
  ...dropzoneProps
}: DropzoneWithContentProps) {
  return (
    <Dropzone
      {...dropzoneProps}
      bd={dropzoneProps.bd || `1px dashed ${THEME_VARS.neutral[3]}`}
      bdrs={5}
      bg={dropzoneProps.disabled ? THEME_VARS.neutral[1] : undefined}
      p="xl"
    >
      <Stack align="center" gap="lg" justify="center" ta="center">
        <Dropzone.Idle>
          <IconUpload
            color={
              dropzoneProps.disabled
                ? THEME_VARS.neutral[3]
                : THEME_VARS.neutral[6]
            }
            size={40}
          />
        </Dropzone.Idle>
        <Dropzone.Accept>
          <IconCircleCheck color={THEME_VARS.success[6]} size={40} />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconCircleX color={THEME_VARS.error[6]} size={40} />
        </Dropzone.Reject>

        <Text
          c={dropzoneProps.disabled ? THEME_VARS.neutral[6] : undefined}
          fw={300}
          inline
          lh="2rem"
          size="sm"
        >
          {textContent ||
            "Ziehen Sie Ihre Datei in dieses Feld oder klicken Sie, um Ihre Datei auszuwählen."}
        </Text>
      </Stack>
    </Dropzone>
  );
}

export { DropzoneWithContent, DropzoneWithContentProps };
